import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const KEY = "ntn_cookie_consent";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem(KEY)) setShow(true);
  }, []);
  if (!show) return null;
  const accept = () => {
    localStorage.setItem(KEY, JSON.stringify({ accepted: true, at: new Date().toISOString() }));
    setShow(false);
  };
  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 z-50 max-w-md bg-[#0A192F] text-white p-5 rounded-sm shadow-xl border border-white/10" data-testid="cookie-banner">
      <div className="font-overline text-white/60 mb-2">Cookies</div>
      <h3 className="font-serif text-lg mb-2">We use only strictly-necessary cookies</h3>
      <p className="text-sm text-white/70 leading-relaxed mb-4">
        Session and security cookies keep you signed in safely. No advertising, no tracking. See our{" "}
        <Link to="/privacy" className="underline">privacy notice</Link>.
      </p>
      <div className="flex gap-2">
        <Button onClick={accept} className="bg-white hover:bg-white/90 text-[#0A192F] rounded-sm" data-testid="cookie-accept">Got it</Button>
      </div>
    </div>
  );
}
